// tslint:disable:no-any
// tslint:disable:no-string-literal

import React, { Component } from 'react';
import { DIVE_TYPES } from '../constants/DiveEnums';
import DiveMap from '../components/DiveMap';
import {
    DEFAULT_MAP_CENTER,
    DEFAULT_MAP_ZOOM
} from '../constants/MapVariables';
import Textarea from 'react-textarea-autosize';
import { DisplayMixture } from '../components/Display';
import { SettingsService } from '../services/SettingsService';
import { convertDiveDataToDisplay } from './DiveData';

export interface IEditDiveFormProps {
    dive: any;
    onChangeDiveData: (e: any) => void;
    onChangeDiveType: (e: any) => void;
    onChangeMixesData: (e: any) => void;
    onChangeGpsData: (e: any) => void;
    submitDivesData: (e: any) => void;
    showConfirmSubmit: (e: any) => void;
    validFields: any;
    requiredFields: any;
    disableSubmit: boolean;
    confirmSubmit: boolean;
}

interface IEditDiveFormState {
    dive: any;
    validFields: any;
    requiredFields: any;
    disableSubmit: boolean;
    center: any;
    zoom: number;
    confirmSubmit: boolean;
    diveId: any;
    profileSettings: any;
}

class EditDiveForm extends Component<IEditDiveFormProps, IEditDiveFormState> {
    constructor(props: IEditDiveFormProps) {
        super(props);
        this.state = {
            center: DEFAULT_MAP_CENTER,
            zoom:
                props.dive.diveAndMixes.dive.latitude !== null &&
                props.dive.diveAndMixes.dive.longitude !== null
                    ? 8
                    : DEFAULT_MAP_ZOOM,
            dive: props.dive,
            validFields: {},
            requiredFields: {},
            disableSubmit: false,
            confirmSubmit: false,
            diveId: undefined,
            profileSettings: null
        };
    }

    componentDidMount() {
        const dive = convertDiveDataToDisplay({...this.state.dive});
        const profileSettings = SettingsService.getInstance().getSettings();

        // přepočet hodnot
        this.setState({
            profileSettings: (profileSettings ? profileSettings.config : null),
            dive: dive
        });
    }

    componentWillReceiveProps(nextProps: IEditDiveFormProps) {
        if (
            nextProps.dive !== this.state.dive ||
            nextProps.validFields !== this.state.validFields ||
            nextProps.requiredFields !== this.state.requiredFields ||
            nextProps.disableSubmit !== this.state.disableSubmit ||
            nextProps.confirmSubmit !== this.state.confirmSubmit
        ) {
            this.setState({
                dive: nextProps.dive,
                validFields: nextProps.validFields,
                requiredFields: nextProps.requiredFields,
                disableSubmit: nextProps.disableSubmit,
                confirmSubmit: nextProps.confirmSubmit
            });
        }
    }

    changeDiveData(e: any) {
        this.props.onChangeDiveData(e);
    }

    onChangeDiveType(e: any) {
        var newDiveType = this.state.dive.diveAndMixes.dive.diveType;
        if (e.target.checked === true) {
            newDiveType.push(e.target.name);
        }

        if (e.target.checked === false) {
            newDiveType = newDiveType.filter((diveType: any) => {
                return diveType !== e.target.name;
            });
        }

        this.props.onChangeDiveType(newDiveType);
    }

    onChangeMixesData(mixesIndex: any, e: any) {
        var newMixData = this.state.dive.diveAndMixes.mixes;
        newMixData[mixesIndex][e.target.name] = e.target.value;

        this.props.onChangeMixesData(newMixData);
    }

    onMapClick(e: any) {
        this.props.onChangeGpsData(e);
    }

    render() {
        if (!this.state.profileSettings) {
            return (<div />);
        }

        return (
            <div>
                <div className="standardContainer__body asDivider">
                    <div className="newDiveForm">
                        <div className="form marginBottom">
                            <div>
                                <p className="inputLabel">Locality</p>
                                <input
                                    type="text"
                                    name="location"
                                    value={
                                        this.state.dive.diveAndMixes.dive
                                            .location !== null
                                            ? this.state.dive.diveAndMixes.dive
                                                  .location
                                            : ''
                                    }
                                    onChange={e => this.changeDiveData(e)}
                                />
                            </div>

                            <div>
                                <p className="inputLabel">Site</p>
                                <input
                                    type="text"
                                    name="site"
                                    value={
                                        this.state.dive.diveAndMixes.dive
                                            .site !== null
                                            ? this.state.dive.diveAndMixes.dive
                                                  .site
                                            : ''
                                    }
                                    onChange={e => this.changeDiveData(e)}
                                />
                            </div>

                            <div
                                className={
                                    this.state.validFields['visibility'] ===
                                    false
                                        ? ' error'
                                        : ''
                                }
                            >
                                <p className="inputLabel">Visibility</p>
                                <div className={`units distance ` + this.state.profileSettings.unitOfLength}>
                                    <input
                                        type="text"
                                        name="visibility"
                                        value={
                                            this.state.dive.diveAndMixes.dive
                                                .visibility !== null
                                                ? this.state.dive.diveAndMixes.dive.visibility
                                                : ''
                                        }
                                        onChange={(e: any) => this.changeDiveData(e)}
                                    />
                                    {this.state.validFields['visibility'] ===
                                        false && (
                                        <div className="alert">
                                            Please enter the real value
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div
                                className={
                                    this.state.validFields['surfaceTemp'] ===
                                    false
                                        ? ' error'
                                        : ''
                                }
                            >
                                <p className="inputLabel">
                                    Surface temperature
                                </p>
                                <div className={`units temperature ` + this.state.profileSettings.unitOfTemperature}>
                                    <input
                                        type="text"
                                        name="surfaceTemp"
                                        value={
                                            this.state.dive.diveAndMixes.dive.surfaceTemp !== null
                                                ? this.state.dive.diveAndMixes.dive.surfaceTemp
                                                : ''
                                        }
                                        onChange={e => this.changeDiveData(e)}
                                    />
                                    {this.state.validFields['surfaceTemp'] ===
                                        false && (
                                        <div className="alert">
                                            Please enter the real value
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="">
                                <p className="inputLabel">Salinity</p>
                                <select
                                    name="salinity"
                                    defaultValue={
                                        this.state.dive.diveAndMixes.dive
                                            .salinity !== null
                                            ? this.state.dive.diveAndMixes.dive
                                                  .salinity
                                            : 'unknown'
                                    }
                                    onChange={e => this.changeDiveData(e)}
                                >
                                    <option value="unknown">Unknown</option>
                                    <option value="seaWater">Sea water</option>
                                    <option value="freshWater">
                                        Fresh water
                                    </option>
                                    <option value="mixed">Mixed</option>
                                </select>
                            </div>

                            <div className="">
                                <p className="inputLabel">Weather</p>
                                <select
                                    name="weather"
                                    defaultValue={
                                        this.state.dive.diveAndMixes.dive
                                            .weather !== null
                                            ? this.state.dive.diveAndMixes.dive
                                                  .weather
                                            : 'unknown'
                                    }
                                    onChange={e => this.changeDiveData(e)}
                                >
                                    <option value="unknown">Unknown</option>
                                    <option value="clear">Clear</option>
                                    <option value="partyCloudy">
                                        Party cloudy
                                    </option>
                                    <option value="cloudy">Cloudy</option>
                                    <option value="windy">Windy</option>
                                    <option value="rain">Rain</option>
                                    <option value="snow">Snow</option>
                                    <option value="storm">Storm</option>
                                </select>
                            </div>

                            <div
                                className={
                                    this.state.validFields['weight'] === false
                                        ? 'error'
                                        : ''
                                }
                            >
                                <p className="inputLabel">Weight</p>
                                <div className={`units weight ` + this.state.profileSettings.unitOfMass}>
                                    <input
                                        type="text"
                                        name="weight"
                                        value={
                                            this.state.dive.diveAndMixes.dive.weight !== null
                                                ? this.state.dive.diveAndMixes.dive.weight
                                                : ''
                                        }
                                        onChange={e => this.changeDiveData(e)}
                                    />
                                    {this.state.validFields['weight'] ===
                                        false && (
                                        <div className="alert">
                                            Please enter the real value
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div>
                                <p className="inputLabel">Partner</p>
                                <input
                                    type="text"
                                    name="partner"
                                    value={
                                        this.state.dive.diveAndMixes.dive
                                            .partner !== null
                                            ? this.state.dive.diveAndMixes.dive
                                                  .partner
                                            : ''
                                    }
                                    onChange={e => this.changeDiveData(e)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="standardContainer__body asDivider">
                    <div className="newDiveForm">
                        <span className="smallTitle">GPS coordinates</span>

                        <div className="form">
                            <div
                                className={
                                    this.state.validFields['latitude'] === false
                                        ? 'error'
                                        : this.state.requiredFields[
                                              'latitude'
                                          ] === true &&
                                          this.state.diveId !== null
                                          ? 'required'
                                          : ''
                                }
                            >
                                <p className="inputLabel">N</p>
                                <div className="units">
                                    <input
                                        type="text"
                                        name="latitude"
                                        value={
                                            this.state.dive.diveAndMixes.dive
                                                .latitude !== null
                                                ? this.state.dive.diveAndMixes
                                                      .dive.latitude
                                                : ''
                                        }
                                        onChange={e => this.changeDiveData(e)}
                                    />
                                    {this.state.validFields['latitude'] ===
                                        false && (
                                        <div className="alert">
                                            Please enter the real value
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div
                                className={
                                    this.state.validFields['longitude'] ===
                                    false
                                        ? 'error'
                                        : this.state.requiredFields[
                                              'longitude'
                                          ] === true &&
                                          this.state.diveId !== null
                                          ? 'required'
                                          : ''
                                }
                            >
                                <p className="inputLabel">E</p>
                                <div className="units">
                                    <input
                                        type="text"
                                        name="longitude"
                                        value={
                                            this.state.dive.diveAndMixes.dive
                                                .longitude !== null
                                                ? this.state.dive.diveAndMixes
                                                      .dive.longitude
                                                : ''
                                        }
                                        onChange={e => this.changeDiveData(e)}
                                    />
                                    {this.state.validFields['longitude'] ===
                                        false && (
                                        <div className="alert">
                                            Please enter the real value
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <DiveMap
                            diveData={this.state.dive.diveAndMixes.dive}
                            point={{
                                lat:
                                    this.state.validFields['latitude'] !==
                                        false &&
                                    this.state.dive.diveAndMixes.dive
                                        .latitude !== null
                                        ? parseFloat(
                                              this.state.dive.diveAndMixes.dive
                                                  .latitude
                                          )
                                        : null,
                                lng:
                                    this.state.validFields['longitude'] !==
                                        false &&
                                    this.state.dive.diveAndMixes.dive
                                        .longitude !== null
                                        ? parseFloat(
                                              this.state.dive.diveAndMixes.dive
                                                  .longitude
                                          )
                                        : null
                            }}
                            center={this.state.center}
                            zoom={this.state.zoom}
                            startupZoom={this.state.zoom}
                            onMapClick={(e: any) => this.onMapClick(e)}
                        />
                    </div>
                </div>

                <div className="standardContainer__body asDivider">
                    <div className="newDiveForm">
                        <span className="smallTitle">Type dive</span>

                        <div className="form cf withCheckboxes">
                            {Object.keys(DIVE_TYPES).map(key => {
                                return (
                                    <div className="cf" key={key}>
                                        <label>
                                            <p className="inputLabel">
                                                {DIVE_TYPES[key]}
                                            </p>
                                            <input
                                                type="checkbox"
                                                name={key}
                                                checked={
                                                    (this.state.dive.diveAndMixes.dive.diveType || []).indexOf(
                                                        key
                                                    ) !== -1
                                                }
                                                onChange={e =>
                                                    this.onChangeDiveType(e)
                                                }
                                            />
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <div className="standardContainer__body asDivider">
                    <div className="newDiveForm">
                        <span className="smallTitle">Description</span>

                        <div className="form cf">
                            <Textarea
                                value={
                                    this.state.dive.diveAndMixes.dive
                                        .description
                                        ? this.state.dive.diveAndMixes.dive
                                              .description
                                        : ''
                                }
                                name="description"
                                onChange={e => this.changeDiveData(e)}
                            />
                        </div>
                    </div>
                </div>

                {this.state.dive.diveAndMixes.mixes.length > 0 && (
                    <div className="standardContainer__body asDivider fullWidth noPaddingBottom">
                        <div className="newDiveForm">
                            <div className="form">
                                <div className="diveDataTable">
                                    <div className="diveDataTable--row">
                                        <div className="diveDataTable--cell">
                                            Mixture
                                        </div>
                                        <div className="diveDataTable--cell">
                                            Tank volume
                                        </div>
                                        <div className="diveDataTable--cell">
                                            Start pressure
                                        </div>
                                        <div className="diveDataTable--cell">
                                            End pressure
                                        </div>
                                    </div>

                                    {this.state.dive.diveAndMixes.mixes.map(
                                        (key: any, index: number) => {
                                            var mixToConfirm = this.state.dive
                                                .diveAndMixes.mixes[index];
                                            return (
                                                <div
                                                    key={index}
                                                    className="diveDataTable--row"
                                                >
                                                    <div className="diveDataTable--cell">
                                                        <DisplayMixture
                                                            data={key}
                                                        />
                                                    </div>
                                                    <div
                                                        className={
                                                            'diveDataTable--cell mixesValueCodeL ' +
                                                            this.state.profileSettings.unitOfVolume +
                                                            (this.state
                                                                .validFields[
                                                                'tankVolume' +
                                                                    index
                                                            ] === false
                                                                ? ' error'
                                                                : '')
                                                        }
                                                    >
                                                        <input
                                                            type="text"
                                                            name="tankVolume"
                                                            key={index}
                                                            value={
                                                                mixToConfirm.tankVolume !==
                                                                null
                                                                    ? mixToConfirm.tankVolume
                                                                    : ''
                                                            }
                                                            onChange={e =>
                                                                this.onChangeMixesData(
                                                                    index,
                                                                    e
                                                                )
                                                            }
                                                        />
                                                        {this.state.validFields[
                                                            'tankVolume' + index
                                                        ] === false && (
                                                            <div className="alert">
                                                                Please enter the
                                                                real value
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div
                                                        className={
                                                            'diveDataTable--cell mixesValueCodeBar ' +
                                                            this.state.profileSettings.unitOfPressure +
                                                            (this.state
                                                                .validFields[
                                                                'startPressure' +
                                                                    index
                                                            ] === false
                                                                ? ' error'
                                                                : '')
                                                        }
                                                    >
                                                        <input
                                                            type="text"
                                                            name="startPressure"
                                                            key={index}
                                                            value={
                                                                mixToConfirm.startPressure !==
                                                                null
                                                                    ? mixToConfirm.startPressure
                                                                    : ''
                                                            }
                                                            onChange={e =>
                                                                this.onChangeMixesData(
                                                                    index,
                                                                    e
                                                                )
                                                            }
                                                        />
                                                        {this.state.validFields[
                                                            'startPressure' +
                                                                index
                                                        ] === false && (
                                                            <div className="alert">
                                                                Please enter the
                                                                real value
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div
                                                        className={
                                                            'diveDataTable--cell mixesValueCodeBar ' +
                                                            this.state.profileSettings.unitOfPressure +
                                                            (this.state
                                                                .validFields[
                                                                'endPressure' +
                                                                    index
                                                            ] === false ||
                                                            this.state
                                                                .validFields[
                                                                'endPressure' +
                                                                    index +
                                                                    'message'
                                                            ] !== null
                                                                ? ' error'
                                                                : '')
                                                        }
                                                    >
                                                        <input
                                                            type="text"
                                                            name="endPressure"
                                                            key={index}
                                                            value={
                                                                mixToConfirm.endPressure !==
                                                                null
                                                                    ? mixToConfirm.endPressure
                                                                    : ''
                                                            }
                                                            onChange={e =>
                                                                this.onChangeMixesData(
                                                                    index,
                                                                    e
                                                                )
                                                            }
                                                        />
                                                        {this.state.validFields[
                                                            'endPressure' +
                                                                index
                                                        ] === false && (
                                                            <div className="alert">
                                                                Please enter the
                                                                real value
                                                            </div>
                                                        )}
                                                        {this.state.validFields[
                                                            'endPressure' +
                                                                index +
                                                                'message'
                                                        ] !== null && (
                                                            <div className="alert">
                                                                {
                                                                    this.state
                                                                        .validFields[
                                                                        'endPressure' +
                                                                            index +
                                                                            'message'
                                                                    ]
                                                                }
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        }
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="standardContainer__body">
                    <div className="newDiveForm center">
                        {this.state.disableSubmit === true && (
                            <button
                                className="btn btn--smallpill btn--backroundRed"
                                disabled
                            >
                                Save
                            </button>
                        )}

                        {this.state.disableSubmit !== true &&
                            this.state.confirmSubmit !== true && (
                                <button
                                    className="btn btn--smallpill btn--backroundRed"
                                    onClick={e => this.props.submitDivesData(e)}
                                >
                                    Save
                                </button>
                            )}

                        {this.state.disableSubmit !== true &&
                            this.state.confirmSubmit === true && (
                                <button
                                    className="btn btn--smallpill btn--backroundRed"
                                    onClick={e =>
                                        this.props.showConfirmSubmit(e)
                                    }
                                >
                                    Save
                                </button>
                            )}
                    </div>
                </div>
            </div>
        );
    }
}

export default EditDiveForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/EditDiveForm.tsx